import React, { useState } from 'react';

import axiosInstance from './axios';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

export default function DeactivateMFADialog({ dialogOpen, setDialogOpen }) {
	const [messageText, setMessageText] = useState('Are you sure you want to deactivate multifactor authentication?');
	const [showDeactivateButton, setShowDeactivateButton] = useState(true);

	const handleClose = () => {
		setDialogOpen(false);
	};

	const handleDeactivate = () => {
		axiosInstance.post(`auth/app/deactivate/`, {})
			.then((res) => {
				if (res.data.length == 0 && res.status == 204) {
					setMessageText('Multifactor authentication has been deactivated.');
					setShowDeactivateButton(false);
				} else {
					setMessageText('An error occurred while deactivating multifactor authentication.');
					setShowDeactivateButton(false);
					console.log('Invalid response from server:', res);
				}
			})
			.catch((error) => {
				setMessageText('An error occurred while deactivating multifactor authentication.');
				setShowDeactivateButton(false);
				console.log(`MFA deactivation failed: ${error}`);
			});
	};

	return (
		<Dialog
			open={dialogOpen}
			onClose={handleClose}
			aria-labelledby='deactivate-mfa-dialog-title'
			maxWidth='xs'
		>
			<DialogTitle id='deactivate-mfa-dialog-title'>
				<Typography variant="h6" component="div" fontFamily='Saira, sans-serif' fontWeight={600}>
					Deactivate Multifactor Authentication
				</Typography>
			</DialogTitle>
			<DialogContent>
				<Typography fontSize='12' fontFamily='Saira, sans-serif' sx={{ marginLeft: 2 }}>
					{messageText}
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={handleClose}
					color='primary'
					variant={ showDeactivateButton ? 'outlined' : 'contained' }
				>
					{ showDeactivateButton ? 'Cancel' : 'Close' }
				</Button>
				{ showDeactivateButton && (
					<Button onClick={handleDeactivate} color='primary' variant='contained'>
						Deactivate
					</Button>
				)}
			</DialogActions>
		</Dialog>
	);
}